import RouterService from '@ember/routing/router-service';
import { createContext, type ReactNode } from 'react';

interface EmberServicesContextProps {
  emberRouter: RouterService;
}

interface EmberServicesContextProviderProps extends EmberServicesContextProps {
  children: ReactNode;
}

export const EmberServicesContext = createContext<EmberServicesContextProps | null>(null);

export function EmberServicesProvider({
  children,
  emberRouter,
}: EmberServicesContextProviderProps): ReactNode {
  return (
    <EmberServicesContext.Provider value={{ emberRouter }}>
      {children}
    </EmberServicesContext.Provider>
  );
}
